export default __webpack_public_path__ + "static/media/header_logo.433d466c.png";